import React from 'react';

export default function AboutUs() {
  return (
    <div style={{ fontFamily: 'Lato', padding: '2rem' }}>
      <section>
        <h2>About Cardacademy</h2>
        <p><strong>Your smart guide to the world of credit cards.</strong></p>

        <h3>Who We Are</h3>
        <p>Cardacademy is India's go-to platform for learning everything about credit cards. Whether you're a beginner looking for your first card or a seasoned user trying to maximize your rewards, we help you make smarter credit decisions.</p>

        <h3>What We Do</h3>
        <p>We simplify the world of credit cards with:</p>
        <ul>
          <li><b>Easy-to-understand blogs</b> that break down card features, rewards, fees, and offers.</li>
          <li><b>Comparisons</b> that help you pick the best card for your needs—travel, shopping, cashback, or premium.</li>
          <li><b>Guides & tips</b> on how to maximize your card benefits and avoid pitfalls like hidden charges or debt traps.</li>
          <li><b>Latest updates</b> on new card launches, bank changes, and limited-time offers you shouldn't miss.</li>
        </ul>

        <h3>Why We Exist</h3>
        <p>The Indian credit card space is growing fast—but it's also confusing. Banks use complicated terms, reward systems change often, and there's a lack of reliable, unbiased advice. That's where we come in. Cardacademy is here to educate, guide, and empower you to get the most value out of your credit journey.</p>

        <h3>Our Promise</h3>
        <ul>
          <li><b>Transparency:</b> We're not here to sell you anything blindly. Our content is honest and fact-checked.</li>
          <li><b>Simplicity:</b> No jargon. No fluff. Just what you need to know—clear and to the point.</li>
          <li><b>Unbiased advice:</b> We may earn from affiliate links, but that never affects our reviews or recommendations.</li>
        </ul>

        <h3>Let's Build Your Credit IQ</h3>
        <p>From card reviews to real-life savings tips, Cardacademy is your partner in becoming a smarter spender and saver. If you ever feel lost in the world of cards—we're just a click away.</p>

        <h3>Contact Us</h3>
        <p>Got questions, suggestions, or want to collaborate?</p>
        <p>Email us at <strong>joincardacademy@gmail.com</strong>.</p>
      </section>
    </div>
  );
}
